import { render } from "./GreatTeaser.vue?vue&type=template&id=24d706a5"
import script from "./GreatTeaser.vue?vue&type=script&lang=js"
export * from "./GreatTeaser.vue?vue&type=script&lang=js"

import "./GreatTeaser.vue?vue&type=style&index=0&id=24d706a5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__